angular.module('app.services').service('tasksService', function (DataTablesFactory, api) {
    const Service = this;

    Service._model = api('task');

    Service.getAll = () => Service._model.list().then((response) => response.data);

    Service.getFiltered = (values) => {
        const params = {
            data: {
                filter: values,
            },
        };

        return Service._model.filter(params).then((response) => {
            // statystyki
            const stats = DataTablesFactory.prepareStats(response.data.stats, {
                fields: ['category_id', 'status_id'],
            });

            return {
                list: response.data.data,
                stats,
            };
        });
    };

    Service.selectize = () =>
        Service._model
            .selectize({
                transform: {
                    id: 'id',
                    value: ':name',
                },
            })
            .then((response) => _.sortBy(response.data, 'label'));

    Service.find = (id) => Service._model.get(id).then((response) => response.data);

    Service.save = (group) => Service._model.post(group);
});
